module.exports = __webpack_public_path__ + "static/media/Mohamed.83a1150a.jpeg";